export default __webpack_public_path__ + "static/VLE-CARS-1920x800-01-Slider-1-9debe5eae1c758bc284da20d6feba47b.webp";